module.exports = __webpack_public_path__ + "media/A7.3c717e2a.wav";